import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { SportConstant } from '@frontend/sports/common/core/data-access/constants';
import { HooksWireup, OnRouteResolve } from '@frontend/sports/common/core/utils/hooks';
import { WinGameFixture } from '@frontend/sports/racing/feature/models';

import { GreyhoundNextRaceModel } from './greyhound-home.resolver';

@HooksWireup()
@Component({
    selector: 'ms-greyhound-home',
    templateUrl: './greyhound-home.component.html',
    standalone: false,
})
export class GreyhoundHomeComponent extends OnRouteResolve<GreyhoundNextRaceModel> {
    nextFixtures: WinGameFixture[] = [];
    sportId: SportConstant;

    constructor(
        public sitecore: Sitecore,
        route: ActivatedRoute,
    ) {
        super(route);
    }

    onRouteResolved(model: GreyhoundNextRaceModel): void {
        if (!model) {
            return;
        }
        this.nextFixtures = model.fixtures;
        this.sportId = this.route.snapshot.data.sport;
    }
}
